import React, { useState, useEffect } from "react";
import './jobSearch.css';

function DreamJob() {





  return (
    <div className="sm:max-w-5xl  " style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="flex w-full   sm:px-9 ">
        <div className="responsivehome  w-full">
          <h1 className="font-semibold text-4xl sm:text-4xl md:text-5xl lg:text-6xl sm:text-left px-6 sm:px-4">
            India's <span className="text-fontBlue">Leading</span> Job Portal!
          </h1>

          <div className="mt-3  text-base sm:text-lg md:text-xl text-zinc-500 text-wrap sm:text-left px-6 sm:px-4 ">
            Optimize your hiring process with advance AI
            based search engine — one solution
          </div>
          <div className=" mb-3 text-base sm:text-lg md:text-xl text-zinc-500 text-wrap  sm:text-left px-6 sm:px-4 ">
            for both
            freshers and experienced professionals.
          </div>

        </div>

      </div>

    </div>
  );
}

export default DreamJob;